import { Svg, Path } from "@react-pdf/renderer";

const CheckCircleFilled = ({ size = 20 }) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM15.5498 6.04492C15.2058 5.73916 14.6788 5.77027 14.373 6.11426L8.29297 12.9531L5.58496 10.2451L5.50684 10.1758C5.17993 9.92159 4.70665 9.94471 4.40625 10.2451C4.08099 10.5705 4.08094 11.0984 4.40625 11.4238L7.74023 14.7568L7.81543 14.8242C8.15666 15.0919 8.65634 15.0543 8.95215 14.7217L15.6191 7.22168L15.6836 7.13867C15.9178 6.7975 15.867 6.3271 15.5498 6.04492Z"
      fill="#00AD3F"
    />
  </Svg>
);

export default CheckCircleFilled;
